(() => {
  const setup = (root = document) => {
    root.querySelectorAll('.bn-editorial-reading').forEach((reading) => {
      const toc = reading.querySelector('[data-article-toc]');
      const content = reading.querySelector('.article-template__content');
      if (!toc || !content || toc.dataset.ready) return;
      const headings = [...content.querySelectorAll('h2, h3')];
      if (headings.length < 2) return;
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = `article-section-${index + 1}`;
          while (document.getElementById(id)) id += '-heading';
          heading.id = id;
        }
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        li.append(link);
        toc.querySelector('ol').append(li);
      });
      toc.hidden = false;
      toc.dataset.ready = 'true';
    });
  };
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
